//@import dependencies
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
import ModalUserFormSkeleton from 'app_components/modules/campus/user/modalUserForm/components/modalUserFormSkeleton'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../modalUserFormModule.scss'
import UserFormModuleLayout from '../../formUser/formUser'
import { UserFormAvatarInputs, UserFormGeneralInfoInputs, UserFormInputs, UserFormSections, UserFormSecurityInputs } from 'app_types/userTypes'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IModalUserFormModuleLayoutProps {
  id: string;
  open          : boolean
  status        : 'loading' | 'error' | null
  userId:   string;
  user          : any
  handleClose   : (data:any)=>void
  origin: UserFormSections
}

const ModalUserFormModuleLayout: React.FC<IModalUserFormModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const {open, user, userId} = props
  const [inputs, setInputs] = useState<UserFormInputs[]>([])

  const { t } = useTranslation()

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  useEffect(() => {
    if (props.origin === UserFormSections.GENERAL_INFO) {
      setInputs([
        UserFormAvatarInputs.AVATAR,
        UserFormGeneralInfoInputs.FIRST_NAME,
        UserFormGeneralInfoInputs.LAST_NAME,
        UserFormGeneralInfoInputs.PHONE_NUMBER,
        UserFormGeneralInfoInputs.EMAIL,
        UserFormGeneralInfoInputs.TIMEZONE,
        UserFormGeneralInfoInputs.CULTURE,
      ])
    } else if (props.origin === UserFormSections.SECURITY) {
      setInputs([
        UserFormSecurityInputs.PASSWORD
      ])
    }
  }, [props.origin])

  return(
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="modal_user_form-component" id={props.id}>
        <Modal.Header>
            <Modal.Title>
            {props.origin ===  UserFormSections.GENERAL_INFO ? (
              <>
                {t('modules.modal_user_form.title')}
              </>
            ): ''}
            </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({status: false})}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {props.status === 'loading' ? (
            <ModalUserFormSkeleton />
          ) : (
            <>
              {props.origin === UserFormSections.GENERAL_INFO ? (
                <TextComponent
                    type='text'
                    className='text-modal-interaction'
                  >
                    Estimado estudiante, recuerde que cualquier cambio en sus datos será aplicado en el certificado y en las notificaciones
                  </TextComponent>
              ): null}
              <UserFormModuleLayout
                userId={userId}
                user={user}
                handleClose={handleCloseModal}
                reviewUserInformation={false}
                inputs={inputs}
              />
            </>
          )}
        </Modal.Body>
      </Modal>
  </div>
  )
}

export default ModalUserFormModuleLayout
